



































import {Component, Vue, Prop} from "vue-property-decorator";
import Product from "@/api/Product";
import RenderProductPrice from "@/components/Shared/RenderProductPrice.vue";
import RenderProductStatus from "@/components/Shared/RenderProductStatus.vue";

@Component({
  components: {RenderProductStatus, RenderProductPrice}
})
export default class CompareTableHeaderCell extends Vue {
  @Prop() private product!: Product;
  @Prop({default: false}) private sticky!: boolean;

  get hideOnStickyClass() {
    if (this.sticky) {
      return "hide-sticky";
    }
    return '';
  }

  removeProduct() {
    this.$emit("product-remove", this.product.id);
  }
}
